/* import __COLOCATED_TEMPLATE__ from './confirm-square-one-pricing.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { trackSquareOneEvent, SquareOneEvents } from '@dashboard/shared-ui/tracking/square-one';
import { convertDateTimeToDate } from '@dashboard/junk-drawer/utils/date-time';
import { captureException } from '@sentry/browser';
export let SquareOnePricingDeviceType = /*#__PURE__*/function (SquareOnePricingDeviceType) {
  SquareOnePricingDeviceType["KIOSK"] = "kiosk";
  SquareOnePricingDeviceType["KDS"] = "kds";
  return SquareOnePricingDeviceType;
}({});
let ConfirmSquareOnePricing = (_class = class ConfirmSquareOnePricing extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "formatter", _descriptor2, this);
    _initializerDefineProperty(this, "dataApi", _descriptor3, this);
    this.trackViewEvent();
  }
  trackViewEvent() {
    trackSquareOneEvent(this.dataApi, SquareOneEvents.DEVICE_CHANGE_MODAL_VIEW, {
      device_type: this.args.deviceType,
      current_payment_subtotal: this.squareOnePricing?.currentCost?.amount || 0,
      proposed_new_incremental_subtotal: (this.count || 0) * (this.squareOnePricing?.unitPrice?.amount || 0),
      proposed_new_payment_subtotal: this.squareOnePricing?.newCost?.amount || 0
    }, this.args.squareOnePricingInfo);
  }
  get count() {
    return this.args.count || 1;
  }
  get isRemoving() {
    if (!this.squareOnePricing) {
      return false;
    }
    // see if we are adding or subtracting
    return this.squareOnePricing.currentCost.amount > this.squareOnePricing.newCost.amount;
  }
  get billingTranslation() {
    const {
      squareOnePricingInfo
    } = this.args;
    const {
      freeTrialEndDate,
      nextFeeDate
    } = this.squareOnePricing;
    if (squareOnePricingInfo?.isInObligatedFreeTrial && !freeTrialEndDate) {
      captureException(new Error('Unexpectedly missing freeTrialEndDate during free trial'));
      return '';
    }
    const formatDate = date => this.intl.formatDate(date, {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
    if (squareOnePricingInfo?.isInObligatedFreeTrial && freeTrialEndDate) {
      return this.intl.t('sharedUi.confirmSquareOnePricing.billingObligatedFreeTrial', {
        freeTrialEndDate: formatDate(freeTrialEndDate)
      });
    }
    if (!nextFeeDate) {
      captureException(new Error('Unexpectedly missing nextFeeDate'));
      return '';
    }
    if (this.isRemoving) {
      return this.intl.t('sharedUi.confirmSquareOnePricing.remove.billing', {
        billingDate: formatDate(nextFeeDate)
      });
    } else {
      return this.intl.t('sharedUi.confirmSquareOnePricing.add.billing', {
        billingDate: formatDate(nextFeeDate)
      });
    }
  }
  get translations() {
    const baseTranslations = {
      perMonth: unitPrice => this.intl.t('sharedUi.confirmSquareOnePricing.perMonth', {
        unitPrice: this.formatter.formatMoney(unitPrice)
      }),
      current: this.intl.t('sharedUi.confirmSquareOnePricing.current'),
      total: this.intl.t('sharedUi.confirmSquareOnePricing.total'),
      preTax: this.intl.t('sharedUi.confirmSquareOnePricing.preTax'),
      button: this.intl.t('sharedUi.confirmSquareOnePricing.button'),
      billing: this.billingTranslation
    };
    if (this.isRemoving) {
      return {
        ...baseTranslations,
        currentCostPerMonth: baseTranslations.perMonth(this.squareOnePricing.currentCost),
        unitPricePerMonth: baseTranslations.perMonth(this.squareOnePricing.unitPrice),
        newCostPerMonth: baseTranslations.perMonth(this.squareOnePricing.newCost)
      };
    } else {
      return {
        ...baseTranslations,
        currentCostPerMonth: baseTranslations.perMonth(this.squareOnePricing.currentCost),
        unitPricePerMonth: baseTranslations.perMonth(this.squareOnePricing.unitPrice),
        newCostPerMonth: baseTranslations.perMonth(this.squareOnePricing.newCost)
      };
    }
  }
  get squareOnePricing() {
    const {
      nextFeeDate,
      currentCost,
      units,
      freeTrialEndAt
    } = this.args.squareOnePricingInfo;
    const device = this.args.deviceType === SquareOnePricingDeviceType.KIOSK ? units.kiosk : units.device;
    return {
      currentCost,
      freeTrialEndDate: convertDateTimeToDate(freeTrialEndAt),
      newCost: device.add(currentCost, this.count),
      nextFeeDate: convertDateTimeToDate(nextFeeDate),
      unitPrice: {
        ...device.cost,
        amount: device.cost.amount * this.count
      }
    };
  }
  get modifiedUnitPrice() {
    if (!this.squareOnePricing) {
      return '';
    }
    // see if we are adding or subtracting
    const modifier = this.isRemoving ? '-' : '';
    return `${modifier}${this.squareOnePricing.unitPrice}`;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ConfirmSquareOnePricing as default };